var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyUsIco1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.556 24.9546C24.9227 25.2548 24.2152 25.4136 23.5138 25.4136C22.7235 25.4136 21.9384 25.216 21.2422 24.8381C19.9092 24.1169 18.9912 22.7899 18.7859 21.2913C18.7203 20.8116 18.659 20.344 18.6012 19.8841C18.1586 20.4587 17.9343 21.0963 18.1336 21.7261C18.6228 23.2696 19.8738 26.2039 18.1336 26.8415C16.3917 27.4773 14.8577 28.0726 15.7291 29.2469C16.7911 30.6808 18.1612 30.1329 19.3794 31.0173C20.1766 31.597 19.5434 32.9291 19.8264 33.7798C18.4416 34.4088 16.9033 34.7573 15.2856 34.7573C12.1288 34.7573 9.27732 33.4252 7.26449 31.2925C7.19547 30.2218 9.51631 30.1545 9.42399 29.1373C9.37395 28.586 9.86745 27.1469 12.6318 26.8415C15.3986 26.5369 14.5661 23.8606 14.1813 22.9426C13.5316 21.394 10.8622 20.9505 8.89166 21.7244C6.91938 22.4983 8.31879 19.6227 9.96408 16.5271C10.719 15.1053 10.2471 14.5229 9.51544 14.3081C11.096 13.3349 12.9389 12.7499 14.9103 12.6835C14.9802 12.9716 15.132 13.3262 15.3969 13.7619C16.3503 15.0483 13.5161 16.4503 13.9596 16.8757C14.4013 17.301 16.2657 17.0241 16.9447 16.3054C17.2803 15.9516 17.7367 15.6678 18.1586 15.4754C17.9662 12.8509 17.949 10.587 18.106 8.69319C17.1906 8.52236 16.2493 8.43091 15.2839 8.43091C6.85554 8.43091 0 15.2873 0 23.7165C0 32.1458 6.85554 39.0013 15.2839 39.0013C23.7131 39.0013 30.5687 32.1458 30.5687 23.7165C30.5687 23.2851 30.5505 22.8581 30.5152 22.4362C29.026 23.2541 27.373 24.0953 25.556 24.9546Z",
    fill: "url(#paint0_linear_2332_167)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0827 1.11383C32.6876 0.358911 31.1847 0 29.7016 0C26.4274 0 23.2542 1.74969 21.5864 4.83235C19.8488 8.04443 20.6935 16.4478 21.3112 20.9419C21.4061 21.6442 21.8323 22.2594 22.4561 22.5967C22.7857 22.7753 23.1506 22.865 23.5164 22.865C23.8417 22.865 24.1652 22.7943 24.4689 22.6511C28.5697 20.7098 36.0671 16.8205 37.8056 13.6084C40.2248 9.13151 38.5622 3.53734 34.0827 1.11383ZM33.1527 10.8872C32.1467 12.7491 29.8181 13.4419 27.9571 12.4342C26.0935 11.4265 25.4024 9.09959 26.4093 7.23688C27.4179 5.37417 29.7439 4.68223 31.6057 5.68994C33.4676 6.69851 34.1621 9.02539 33.1527 10.8872Z",
    fill: "url(#paint1_linear_2332_167)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2332_167",
    x1: 15.2832,
    y1: 8.43091,
    x2: 15.2832,
    y2: 38.9994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2332_167",
    x1: 29.7341,
    y1: 0,
    x2: 29.7341,
    y2: 22.8636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyUsIco1);
export default __webpack_public_path__ + "static/media/why-us-ico-1.fafc73cd02f900c613f57f26a6437ddf.svg";
export { ForwardRef as ReactComponent };